import { defineAction, object, string } from '~/prix'
import systemExportRfbSftpAction from './systemExportRfbSftp.action.json' with { type: 'json' }

const systemExportRfbSftpDefinition = defineAction({
  ...systemExportRfbSftpAction,
  input: object({}),
  output: object({
    success: string(),
  }),
})

export default systemExportRfbSftpDefinition
